import React from 'react';
import { PanelGuidanceFragment } from '../containers/panel-guidance-container';
import { entryInnerRoutePaths, storyStepsPath } from '../models/path-model';

export interface GuidanceEntry {
  innerPath: string;
  content: React.ReactNode;
}

const Step1Guidance = (
  <>
    <PanelGuidanceFragment
      title="Fique ligado!"
      sections={[
        {
          type: 'text',
          content:
            'Espaço ocupacional se refere ao tipo de relação contratual que o(a) concorrente tem com o Sebrae, com empresas contratadas pela instituição, com prefeituras municipais ou parceiros privados. Trata-se do cargo ocupado.',
        },
      ]}
    />
    <PanelGuidanceFragment
      title="Categoria"
      sections={[
        {
          type: 'text',
          content:
            'A categoria a ser escolhida com base na contextualização e critérios apontados no Regulamento',
        },
      ]}
    />
  </>
);

export const guidanceConfig: GuidanceEntry[] = [
  {
    innerPath: entryInnerRoutePaths.newStory,
    content: Step1Guidance,
  },

  {
    innerPath: storyStepsPath({ step: 1 }),
    content: Step1Guidance,
  },

  {
    innerPath: storyStepsPath({ step: 2 }),
    content: (
      <>
        <PanelGuidanceFragment
          title="Unidade que você trabalha"
          sections={[
            {
              type: 'dash-list',
              subtitle:
                'No campo Unidade, você deve listar o nome do seu local de trabalho ou de vínculo contratual (no caso dos agentes), como os exemplos abaixo:',
              items: [
                'Regional Leste - Sebrae/AL;',
                'CNR/BA (TEL)',
                'CNR/ES (Sollo)',
                'Sala do Empreendedor de Luziânia/GO',
                'Posto Sebrae Aqui - Ilha Solteira/SP',
              ],
            },
          ]}
        />
        <PanelGuidanceFragment
          title="Sua foto"
          sections={[
            {
              type: 'dash-list',
              subtitle: 'A foto deve ser:',
              items: [
                'Formato horizontal',
                'Rosto de frente',
                'Extensões: JPG ou PNG',
                'Em boa resolução',
                'Boa iluminação',
                'Colorida',
                'Sem outros participantes',
              ],
            },
            {
              type: 'dash-list',
              subtitle: 'Capriche!',
              items: [
                'Utilizaremos esta foto nas cerimônias de revelação e premiação, caso você esteja entre os(as) vencedores(as)',
              ],
            },
          ]}
        />
      </>
    ),
  },

  {
    innerPath: storyStepsPath({ step: 3 }),
    content: (
      <PanelGuidanceFragment
        title="Dicas"
        sections={[
          {
            type: 'bullet-list',
            items: [
              'No vídeo, a história deve ser contada pelo(a) atendente que vivenciou a história (que realizou o atendimento), ou seja, a narração/contação da história não pode ser feita por um terceiro.',
              'O vídeo deve ter, no máximo, 3 minutos de duração.',
              'O número de curtidas no vídeo é critério de desempate, ao finalizar a sua inscrição, divulgue seu vídeo para amigos e parentes.',
              'A participação do(a) cliente no vídeo é opcional.',
              'Lembre-se: o Histórias de Quem Atende além de prêmio é também um repositório de histórias reais de atendimento, por isso, um título representativo e criativo, faz toda a diferença quando buscamos personagens da vida real para campanhas internas, publicitárias e para redes sociais.',
            ],
          },
        ]}
      />
    ),
  },

  {
    innerPath: storyStepsPath({ step: 4 }),
    content: (
      <PanelGuidanceFragment
        title="Como funciona a autorização de imagem?"
        sections={[
          {
            type: 'bullet-list',
            items: [
              'Ao realizar a inscrição, o(a) participante concorda com todos os termos do Regulamento e autoriza, de forma gratuita, sem quaisquer ônus, em caráter universal, definitivo, irrevogável e irretratável, o Sebrae, a divulgar sua imagem e recursos audiovisuais, para uso institucional e promocional.',
              'Para clientes e/ou participantes, a autorização de uso de imagem é obrigatória para todas as pessoas que estão no vídeo, ou seja, para todas as pessoas que interagem com a câmera/celular.',
              'A participação de crianças e adolescentes nos vídeos, exige expressa autorização dos pais (pai e/ou mãe) ou do responsável legal, conforme determina o Estatuto da Criança e do Adolescente.',
            ],
          },
        ]}
      />
    ),
  },

  {
    innerPath: entryInnerRoutePaths.storyReview,
    content: (
      <PanelGuidanceFragment
        title="Confira os dados da historia"
        sections={[
          {
            type: 'text',
            content: [
              'Revisar os dados inseridos é crucial para evitar erros e garantir a precisão das informações.',
              '',
              'Antes de enviar qualquer formulário ou documento, é importante conferir cada detalhe.',
              '',
              'Isso não apenas ajuda a prevenir mal-entendidos, mas também assegura que as informações sejam apresentadas corretamente.',
              '',
              'Uma revisão cuidadosa pode evitar desqualificações e garantir que tudo esteja em ordem.',
            ].join('\n'),
          },
        ]}
      />
    ),
  },

  {
    innerPath: entryInnerRoutePaths.storyResume,
    content: (
      <PanelGuidanceFragment
        title="Inscrição finalizada com sucesso!"
        sections={[
          {
            type: 'text',
            content: [
              'A partir de agora não será possível alterar dados nesta inscrição. Nos encontramos na Cerimônia de Revelação dos Vencedores.',
              '',
              'Boa sorte!',
            ].join('\n'),
          },
        ]}
      />
    ),
  },
];
